<template>
  <footer>
    <div class="footer" v-if="isShowApplication">
      <nuxt-link target="_blank" to="/privacy-application" class="footer__link">プライバシーポリシー</nuxt-link>
      <nuxt-link target="_blank" to="/terms-application" class="footer__link">利用規約</nuxt-link>
      <nuxt-link target="_blank" to="/contact-application" class="footer__link">お問い合わせ</nuxt-link>
    </div>
    <div class="footer" v-else>
      <nuxt-link target="_blank" to="/privacy" class="footer__link">プライバシーポリシー</nuxt-link>
      <nuxt-link target="_blank" to="/terms" class="footer__link">利用規約</nuxt-link>
      <nuxt-link target="_blank" to="/contact" class="footer__link">お問い合わせ</nuxt-link>
    </div>
  </footer>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'f-footer',
  computed: {
    ...mapState({
      isRoleApplication: state => state.frontend.auth.isRoleApplication,
    }),
    isShowApplication() {
      return this.isRoleApplication || this.pageNameApplications.includes(this.$route.name)
    }
  },
  data() {
    return {
      pageNameApplications: [
        'auth-login-application',
        'auth-register-application',
        'auth-register-application-confirm',
        'auth-forgot-password-application',
        'auth-forgot-password-application-token',
      ]
    }
  },
}
</script>
